import { MainLayout } from "./MainLayout";
import { MainLayoutContent } from "./MainLayoutContent";
import { MainLayoutMobileHeader } from "./MainLayoutMobileHeader";

export function MainLayoutFallback() {
  return (
    <MainLayout>
      <MainLayoutMobileHeader header="" />
      <MainLayoutContent>
        <div className="min-h-[calc(100dvh-80px-77px)]  lg:min-h-screen flex items-center justify-center">
          Loading...
        </div>
      </MainLayoutContent>
    </MainLayout>
  );
}
